import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=4fde489e"
import script from "./Users.vue.ts?vue&type=script&lang=ts&external"
export * from "./Users.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports